import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { IconBase } from '../internal/IconBase.js';
/**
 * `Users` — two users side by side.
 *
 * Canonical use: user-account glyphs in profile, auth, access control.
 * Aria label:    Users
 * Family:        user-account
 * Related:       user, user-plus, user-minus, user-check, user-x, user-cog
 * Audited 2026-09-20 — no-op (5/5 criteria pass). Users.
 *
 */
export const Users = forwardRef(function Users(props, ref) {
    return (_jsxs(IconBase, { ref: ref, ...props, children: [_jsx("circle", { cx: "9", cy: "8", r: "3.5" }), _jsx("path", { d: "M2 20 a7 7 0 0 1 14 0" }), _jsx("circle", { cx: "17", cy: "6", r: "2.5" }), _jsx("path", { d: "M16 20 a6 6 0 0 1 6 -6" })] }));
});
//# sourceMappingURL=users.js.map